var map = {
	"./castellers_d_estonia.svg": 6491,
	"./castellers_de_l_adroc.svg": 889,
	"./castellers_del_collell.svg": 3822,
	"./colla_castellera_senglars_de_canyelles.svg": 2215,
	"./colla_dels_xiquets_de_valls_la_barreja.svg": 5829,
	"./colla_jove_dels_castellers_de_vilafranca.svg": 3192,
	"./los_xics_caleros.svg": 3720,
	"./tirallongues_de_manresa.svg": 4347,
	"./xicots_de_valls.svg": 9349,
	"./xiquets_de_tarragona.svg": 5221,
	"./xiquets_de_torredembarra.svg": 1276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;